// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    TableCell,
    DialogActions,
    Tooltip
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import MsiDatagridAutoFilter from '../../../../components/custom/MsiDatagridAutoFilter';
import moment from 'moment'
import 'moment/locale/id'
import { useToast } from '../../../../components/ToastProvider';
import Swal from 'sweetalert2';
import AttachmentFab from '../../../../components/attachment/AttachmentFab';

export default function Detail() {
    const { showToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const hiddenDoctag = [
        12604000006,
        12604000007,
        12604000008,
        12604000009,
        12604000010
    ]
    const { id } = useParams();

    // ** State
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [openBarang, setOpenBarang] = useState<boolean>(false)
    const [isAdd, setIsAdd] = useState<boolean>(false)
    const [openDetail, setOpenDetail] = useState<boolean>(false)

    const [isDetailBarang, setIsDetailBarang] = useState<boolean>(false)
    const [listDetailBarang, setListDetailBarang] = useState<any[]>([])

    const [rowsDataDetail, setRowsDataDetail] = useState<any[]>([])

    const [listTimeline, setListTimeline] = useState<any[]>([])

    const [tglDokumen, setTglDokumen] = useState<string>(moment().format('YYYY-MM-DD'))

    const [isWO, setIsWO] = useState<boolean>(false)
    const [linkWo, setLinkWo] = useState<string>('')

    const [listWO, setListWO] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const [isOto, setIsOto] = useState<any>(null)
    const [otNow, setOtNow] = useState<any>(null)
    const [isAktif, setIsAktif] = useState<any>(null)
    const [isKirimWa, setIsKirimWa] = useState<any>(null)

    useEffect(() => {
        getDetail()
        getTimeline()
    }, [])

    const getDetail = () => {
        showToast("Loading", "loading");
        const url = apiUrl.apiUrl + '/purchasing/pr/get-data-pr/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    getCheck(data.sysdoctag_id)
                    setOtNow(data.ot_now)
                    setIsAktif(data.is_aktif)
                    setIsKirimWa(data.is_kirim_whatsapp)

                    setTglDokumen(data.stgl)
                    setValue('keterangan', data.keterangan)
                    setValue('kode_wo', data.kode_wo)

                    if (data.kode_wo != null && data.kode_wo != 0) {
                        setIsWO(true)
                        setLinkWo(data.link)
                    } else {
                        setIsWO(false)
                        setValue('kode_wo', null)
                    }

                    getDoctag(data.sysdoctag_id)
                    getDetailBarang()
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const getCheck = (doctag: any) => {
        const url = apiUrl.apiUrl + '/purchasing/po/get-cek-oto-user'
        axios
            .get(url, {
                params: { sysdoctag_id: doctag },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setIsOto(data)

                    // Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDetailBarang = () => {
        const url = apiUrl.apiUrl + '/purchasing/pr/get-barang-pr-wo/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data;
                    setListDetailBarang(data)
                    setRowsDataDetail(data)

                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const getDoctag = (doctag: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 37
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == doctag) {
                            setValDoctag(element)
                            setValue('sysdoctag_id', element.id)
                        }
                    });
                    setListDoctag(data)
                } else {
                    showToast(response.data.message, "error");
                }
            })

    }

    const getTimeline = () => {
        const url = apiUrl.apiUrl + '/purchasing/pr/timeline/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListTimeline(data)
                } else {
                    showToast(response.data.message, "error");
                }
            })

    }

    const getListMasterBarangNew = () => {
        const url = apiUrl.apiUrl + '/purchasing/pr/list-barang'
        axios
            .get(url, {
                params: {sysdoctag_id:sysdoctagId},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDetailBarang(data)
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }

    const navigate = useNavigate();
    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        keterangan: any,
        detailBarang: any
        total: any,
        id_pr: any,
        kode_wo: any,

        // untuk detail
        pbpr_d_id: any,
        tgl_kebutuhan: any,
        mmbarang_id: any,
        nama_barang: any,
        mmsatuan_id: any,
        qty: any,
        satuan: any,
        keterangan_detail: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        id_pr: id
    }

    const {
        control,
        handleSubmit,
        setValue,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
        if (newValue.id == 12512000001) {
            setIsWO(true)
        } else {
            setIsWO(false)
            setValue('kode_wo', null)
        }
    }

    const handleClickDialog = (x: any) => {
        setOpenBarang(true)
        getListMasterBarangNew()
        setIsDetailBarang(x)
    }
    const handleCloseDialog = () => setOpenBarang(false)

    const rowClickBarang = (e: any) => {
        const data = e.data
        addDetailBarangNew(data.id)
        setOpenBarang(false)
    }

    const addDetailBarangNew = (mb_id: any) => {

        const url = apiUrl.apiUrl + '/purchasing/pr/check-barang/' + mb_id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0];
                    setValue('mmbarang_id', data.mmbarang_id);
                    setValue('nama_barang', data.nama_barang);
                    setValue('mmsatuan_id', data.mmsatuan_id);
                    setValue('satuan', data.satuan);
                    setValue('keterangan_detail', data.keterangan_detail);
                    setValue('tgl_kebutuhan', data.tgl_kebutuhan?.split(" ")[0]);
                    setValue('pbpr_d_id', null);
                    setIsAdd(true);
                    setOpenDetail(true)
                } else {
                    showToast(response.data.message, "error");
                }
            })
    }


    setValue('detailBarang', JSON.stringify(rowsDataDetail))
    const sumBarang = rowsDataDetail.reduce(sum, 0)

    function sum(accumulator: any, a: any) {
        return accumulator + a.Total
    }

    setValue('total', sumBarang)

    const onSubmit = (data: any) => {
        showToast("Saving...", "loading");

        const url = apiUrl.apiUrl + '/purchasing/pr/save-pr'
        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, "success");
                    navigate('/purchasing/purchase-request')
                } else {
                    showToast(response.data.message, "error");
                }
            })
            .catch(error => {
                showToast(error.message, "error");
            })
    }

    const rowClickWO = (e: any) => {
        const data = e.data
        setValue('kode_wo', data?.id)
        setOpenDialog(false)
    }

    const convertComponent = [
        {
            key: 'link',
            minWidth: 300,
            renderCell: ({ row }: any) => {
                const url = row.data?.link;

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }

                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 400,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                        didClose: () => {
                            setOpenDialog(true);
                        }
                    });
                };

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenDialog(false);
                            openImage()
                        }}
                    />
                );
            }
        }
    ];

    const onBatalPR = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin batal PR ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Batal',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(116, 107, 107)'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/pr/batal-pr/' + id
                axios
                    .post(url, {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/purchasing/purchase-request')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const onBatalOto = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin batal otorisasi data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Batal'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/pr/batal-oto-pr/' + id
                axios
                    .post(url, {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/purchasing/purchase-request')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const onOtorisasiPR = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin otorisasi data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(116, 107, 107)',
            confirmButtonText: 'Otorisasi'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/pr/oto-pr/' + id
                axios
                    .post(url, {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/purchasing/purchase-request')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(116, 107, 107)',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const data = {}
                const url = apiUrl.apiUrl + '/purchasing/pr/hapus-barang/' + row.id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getDetail()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };
    const ActionButtons = ({
        row
    }: {
        row: any
    }) => {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {
                    row.id != null && isAktif == 0 ?
                        <>
                            <Tooltip key='Hapus Data' title='Hapus Data' placement='top'>
                                <a
                                    onClick={() => handleDelete(row)}
                                    style={{ cursor: 'pointer', textDecoration: 'none' }}
                                >
                                    <IconButton component='span'>
                                        <Icon icon='mdi:trash' color='#d63031' />
                                    </IconButton>
                                </a>
                            </Tooltip>
                            <Tooltip key='Edit Data' title='Edit Data' placement='top'>
                                <a
                                    onClick={() => {
                                        setValue('pbpr_d_id', row.id)
                                        setValue('tgl_kebutuhan', row.tgl_kebutuhan)
                                        setValue('mmbarang_id', row.mmbarang_id)
                                        setValue('nama_barang', row.nama_barang)
                                        setValue('mmsatuan_id', row.mmsatuan_id)
                                        setValue('satuan', row.satuan)
                                        setValue('qty', row.qty_pr)
                                        setValue('keterangan_detail', row.keterangan)
                                        setIsAdd(false)
                                        setOpenDetail(true)
                                    }}
                                    style={{ cursor: 'pointer', textDecoration: 'none' }}
                                >
                                    <IconButton component='span'>
                                        <Icon icon='mdi:pencil' color='#0984e3' />
                                    </IconButton>
                                </a>
                            </Tooltip>
                        </>
                        : null
                }
                {row.id == null &&
                    <>
                        <Tooltip title="Isi PR" placement="top">
                            <Button
                                variant="contained"
                                size="small"
                                sx={{ px: 3, py: 1 }}
                                startIcon={<Icon icon="mdi:pencil" />}
                                onClick={() => {
                                    setValue('mmbarang_id', row.mmbarang_id);
                                    setValue('nama_barang', row.nama_barang);
                                    setValue('mmsatuan_id', row.mmsatuan_id);
                                    setValue('satuan', row.satuan);
                                    setValue('keterangan_detail', row.keterangan);
                                    setValue('pbpr_d_id', null);
                                    setIsAdd(true);
                                    setOpenDetail(true)
                                }}
                            >
                                Buat PR
                            </Button>
                        </Tooltip>
                    </>
                }

            </Box>
        )
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                />
            ),
        },
    ];

    const sysdoctagId = watch('sysdoctag_id')

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Purchase Request
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        Tgl Dokumen : <b>{moment(tglDokumen).format('LL')}</b>
                    </Typography>
                    {isAktif == 0 ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
                            <Tooltip title='Kirim WhatsApp Otorisasi'>
                                <Button
                                    variant='contained'
                                    color={isKirimWa ? 'warning' : 'success'}
                                    startIcon={isKirimWa ? <Icon icon='mdi:reload' /> : <Icon icon='mdi:whatsapp' />}
                                    onClick={() => {
                                        Swal.fire({
                                            title: 'Konfirmasi',
                                            text: 'Kirim pesan WhatsApp untuk otorisasi?',
                                            icon: 'question',
                                            showCancelButton: true,
                                            confirmButtonText: 'Kirim',
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: 'rgb(116, 107, 107)'
                                        }).then(result => {
                                            if (result.isConfirmed) {
                                                Swal.fire({
                                                    title: 'Now loading',
                                                    allowEscapeKey: false,
                                                    allowOutsideClick: false,
                                                    didOpen: () => {
                                                        Swal.showLoading()
                                                    }
                                                })

                                                const url = apiUrl.apiUrl + '/purchasing/pr/kirim-otorisasi/' + id
                                                axios.post(url, {}, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                }).then(response => {
                                                    if (response.data.success) {
                                                        Swal.fire({
                                                            title: 'Berhasil',
                                                            text: response.data.message,
                                                            icon: 'success',
                                                            timer: 1000
                                                        })
                                                    } else {
                                                        Swal.fire({
                                                            title: 'Gagal',
                                                            text: response.data.message,
                                                            icon: 'error'
                                                        })
                                                    }
                                                }).catch(error => {
                                                    Swal.fire({
                                                        title: 'Error',
                                                        text: error.message,
                                                        icon: 'error'
                                                    })
                                                })
                                            }
                                        })
                                    }}
                                >
                                    {isKirimWa ? 'Kirim Ulang Notifikasi Whatsapp' : 'Kirim WhatsApp Otorisasi'}
                                </Button>
                            </Tooltip>
                        </Box>
                    ) :
                        null
                    }
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Document Tag
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                disabled={true}
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan PR
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan PR'
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {isWO ? (
                                <>
                                    <Grid item xs={12} md={6} sm={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='kode_wo'
                                                control={control}
                                                render={({ field: { value } }) => (
                                                    <TextField
                                                        label='Kode WO'
                                                        type='text'
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} sm={6} display="flex" alignItems="center">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                if (!linkWo) {
                                                    Swal.fire({
                                                        icon: 'warning',
                                                        title: 'Gambar tidak tersedia',
                                                        text: 'Link gambar WO belum ada'
                                                    })
                                                    return
                                                }

                                                Swal.fire({
                                                    title: 'Gambar Work Order',
                                                    imageUrl: linkWo,
                                                    imageAlt: 'Gambar WO',
                                                    width: '60%',
                                                    showCloseButton: true,
                                                    confirmButtonText: 'Tutup'
                                                })
                                            }}
                                        >
                                            Lihat Gambar
                                        </Button>
                                    </Grid>
                                </>
                            ) : ('')}
                            <Grid item xs={12} sm={12}>
                                <Box sx={{ backgroundColor: '#ffeaa7', p: 1 }}>
                                    <Typography variant='body1' sx={{ color: '#212121', textAlign: 'center', fontWeight: 600 }}>
                                        DETAIL BARANG
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        mb: 1,
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    {
                                        isAktif == 0 ?

                                            <Fab
                                                variant='extended'
                                                color='primary'
                                                sx={{ '& svg': { mr: 1 } }}
                                                onClick={() => handleClickDialog(true)}
                                            >
                                                <Icon icon='mdi:search' />
                                                Cari Barang
                                            </Fab>
                                            : null
                                    }
                                    {!hiddenDoctag.includes(Number(sysdoctagId)) && (
                                        <Fab
                                            variant='extended'
                                            color='primary'
                                            sx={{ '& svg': { mr: 1 } }}
                                            onClick={() => window.open('/mm/master-barang/add', '_blank')}
                                        >
                                            <Icon icon='mdi:plus' />
                                            Tambah Master Barang
                                        </Fab>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <MsiDatagrid array={rowsDataDetail} hiddenColumns={['id', 'flag_color', 'mmbarang_id', 'tgl_kebutuhan']} actions={actionData} rowStyleRules={[
                                    { field: 'id', operator: '==', value: null, color: '#ff8787ff' },
                                ]} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box sx={{ backgroundColor: '#ffeaa7', p: 1 }}>
                                    <Typography variant='body1' sx={{ color: '#212121', textAlign: 'center', fontWeight: 600 }}>
                                        TIMELINE
                                    </Typography>
                                </Box>
                                <MsiDatagrid array={listTimeline} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 2,
                                        mt: 5
                                    }}
                                >
                                    {(() => {
                                        if (isOto == '0' && isAktif == '1') {
                                            return (
                                                <Button
                                                    size="large"
                                                    color="inherit"
                                                    sx={{ width: { xs: '100%', sm: 150 } }}
                                                    onClick={() => navigate('/purchasing/purchase-request/')}
                                                    variant="contained"
                                                >
                                                    BACK
                                                </Button>
                                            )
                                        } else if (isOto == '0' && otNow == '0' && isAktif == '0') {
                                            return (
                                                <>
                                                    <Button
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        onClick={() => navigate('/purchasing/purchase-request/')}
                                                        variant="contained"
                                                    >
                                                        BACK
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        onClick={onBatalPR}
                                                    >
                                                        BATAL PR
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        type="submit"
                                                    >
                                                        Simpan
                                                    </Button>
                                                </>
                                            )
                                        } else if (isOto < otNow && otNow > 0 && isAktif == '0') {
                                            return (
                                                <>
                                                    <Button
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        onClick={() => navigate('/purchasing/purchase-request/')}
                                                        variant="contained"
                                                    >
                                                        BACK
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        onClick={onBatalPR}
                                                    >
                                                        BATAL PR
                                                    </Button>
                                                </>
                                            )
                                        } else if (isOto > otNow && isAktif == '0') {
                                            return (
                                                <>
                                                    <Button
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        onClick={() => navigate('/purchasing/purchase-request/')}
                                                        variant="contained"
                                                    >
                                                        BACK
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        onClick={onBatalPR}
                                                    >
                                                        BATAL PR
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        type="submit"
                                                    >
                                                        Simpan
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="success"
                                                        sx={{ width: { xs: '100%', sm: 250 } }}
                                                        variant="contained"
                                                        onClick={() => onOtorisasiPR()}
                                                    >
                                                        Otorisasi & Simpan
                                                    </Button>
                                                </>
                                            )
                                        } else if (isOto == otNow && otNow > 0 && isAktif == '0') {
                                            return (
                                                <>
                                                    <Button
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        onClick={() => navigate('/purchasing/purchase-request/')}
                                                        variant="contained"
                                                    >
                                                        BACK
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        onClick={onBatalPR}
                                                    >
                                                        BATAL PR
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 250 } }}
                                                        variant="contained"
                                                        onClick={onBatalOto}
                                                    >
                                                        Batal Otorisasi
                                                    </Button>
                                                </>
                                            )
                                        } else if (isOto == otNow && otNow > 0) {
                                            return (
                                                <>
                                                    <Button
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        onClick={() => navigate('/purchasing/purchase-request/')}
                                                        variant="contained"
                                                    >
                                                        BACK
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 250 } }}
                                                        variant="contained"
                                                        onClick={onBatalOto}
                                                    >
                                                        Batal Otorisasi
                                                    </Button>
                                                </>
                                            )
                                        } else if (isOto < otNow && otNow > 0 && isAktif == '1') {
                                            return (
                                                <Button
                                                    size="large"
                                                    color="inherit"
                                                    sx={{ width: { xs: '100%', sm: 150 } }}
                                                    onClick={() => navigate('/purchasing/purchase-request/')}
                                                    variant="contained"
                                                >
                                                    BACK
                                                </Button>
                                            )
                                        } else if (isOto < otNow && otNow > 0) {
                                            return (
                                                <>
                                                    <Button
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        onClick={() => navigate('/purchasing/purchase-request/')}
                                                        variant="contained"
                                                    >
                                                        BACK
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        onClick={onBatalPR}
                                                    >
                                                        BATAL PR
                                                    </Button>
                                                </>
                                            )
                                        } else if (isOto == '0' && otNow == '0') {
                                            return (
                                                <>
                                                    <Button
                                                        size="large"
                                                        color="inherit"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        onClick={() => navigate('/purchasing/purchase-request/')}
                                                        variant="contained"
                                                    >
                                                        BACK
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        color="error"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        onClick={onBatalPR}
                                                    >
                                                        BATAL PR
                                                    </Button>
                                                    <Button
                                                        size="large"
                                                        sx={{ width: { xs: '100%', sm: 150 } }}
                                                        variant="contained"
                                                        type="submit"
                                                    >
                                                        Simpan
                                                    </Button>
                                                </>
                                            )
                                        } else {
                                            return (
                                                <Button
                                                    size="large"
                                                    color="inherit"
                                                    sx={{ width: { xs: '100%', sm: 150 } }}
                                                    onClick={() => navigate('/purchasing/purchase-request/')}
                                                    variant="contained"
                                                >
                                                    BACK
                                                </Button>
                                            )
                                        }
                                    })()}
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDetail}
                onClose={() => setOpenDetail(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = ''
                    if (isAdd) {
                        url = apiUrl.apiUrl + '/purchasing/pr/save-pr-detail/' + id
                    } else {
                        url = apiUrl.apiUrl + '/purchasing/pr/save-edit-detail'
                    };


                    axios.post(url, {
                        id: isAdd ? null : data.pbpr_d_id,
                        tgl_kebutuhan: data.tgl_kebutuhan,
                        mmbarang_id: data.mmbarang_id,
                        qty: data.qty,
                        mmsatuan_id: data.mmsatuan_id,
                        keterangan: data.keterangan_detail
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDetail(false);
                                getDetail();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDetail(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Request Barang
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kebutuhan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='date'
                                                label='Tanggal Kebutuhan'
                                                value={value || ''}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.tgl_kebutuhan && (
                                    <FormHelperText error>Tanggal kebutuhan wajib diisi</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_barang'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                value={value || ''}
                                                label='Nama Barang'
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.nama_barang && (
                                    <FormHelperText error>Nama barang wajib diisi</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='number'
                                                label='Qty'
                                                value={value || ''}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.qty && (
                                    <FormHelperText error>Qty wajib diisi</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='satuan'
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                value={value || ''}
                                                label='Satuan'
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_detail'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                multiline
                                                rows={3}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.keterangan_detail && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDetail(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                onClose={handleCloseDialog}
                aria-labelledby='customized-dialog-title'
                open={openBarang}
                fullWidth={true}
                maxWidth='xl'
            >
                <DialogTitle id='customized-dialog-title'>
                    {isDetailBarang ? (
                        <Typography variant='h6' component='span' sx={{ color: '#212121' }}>
                            Pilih Barang
                        </Typography>
                    ) : (
                        <Typography variant='h6' component='span' sx={{ color: '#212121' }}>
                            Pilih Akun
                        </Typography>
                    )}
                    <IconButton
                        aria-label='close'
                        onClick={handleCloseDialog}
                        sx={{ top: 10, right: 10, position: 'absolute', color: 'grey.500' }}
                    >
                        <Icon icon='mdi:close' />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <MsiDatagrid array={listDetailBarang} rowClick={rowClickBarang} hiddenColumns={['Batch', 'Asset', 'Stock', 'Sales', 'KelasBarang']} />
                </DialogContent>
            </Dialog>

            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List WO
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listWO} rowClick={rowClickWO} hiddenColumns={['id']} customRender={convertComponent} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

            <AttachmentFab
                docId={Number(id)}
                docType="pbpr"
            />
        </Grid>
    )
}
